const COLORS = {
  lightBlue: '#007aff',
  darkBlue: '#1E4D80',
}

export default COLORS
